import React,{ useEffect, useState }  from "react";
import './dashboard_api_item.css';
import './api_dashboard.css';
import { FiCopy } from "react-icons/fi";
import CodeBlock from "./code_block";
import { FaCheck } from "react-icons/fa";



const DashBoardAPIItem = ({section}) =>{

    const [data, setData] = useState(null);

  

    return(
        section.title == "Setup"?
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div className="left-container-setup">
            <h2>{section.title}: </h2>
            <p>
               <strong>Disclaimer:</strong> The data provided by stockarchives / stockarchives-api is for 
               informational purposes only and should not be relied on for investment decisions.
                We are not responsible for any financial losses, gains, 
                or other outcomes resulting from use of this data, including 
                inaccuracies or misinterpretations. For official and most accurate information, 
                please consult trusted sources such as the <a href="https://www.sec.gov/search-filings" 
                target="_blank" rel="noopener noreferrer"><strong>SEC</strong></a> and company investor
                 relations websites.
            </p>
        </div>
        
        <div className="section-placeholder-dashboard-item-setup">
            <p>
                <strong>1. Access the API </strong>  
                Use the Base URL (e.g. `https://stockarchives-api.com`) 
                to construct your requests.</p>

            <p>
                <strong>2. Obtaining Your API Key </strong>  
                Navigate to your profile and click “Generate API Key.”  
                <em>Important: </em> 
                Copy and securely store your API key immediately — it will not be shown again. If lost, you'll need to generate a new one.
                </p>

            <p>
                <strong>3. Make Requests </strong>  
                Use tools like Postman, cURL, or Insomnia to send requests to the API. 
                Include your API key in 
                the `Authorization` parameter for authentication.
            </p>
        </div>
    </div>
    :<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div className="left-container">
                <h2 className="api-header-c">{section.title}:</h2>
                <p className="api-header-c-endpoint">{`/${section.endpoint}`}</p>
                <p>{section.content}</p>
                <p><strong>Request Fields: </strong></p>
                {
                            section.column &&
                            
                            section.column.map((field) => (
                                <div className="api-request-fields-item">
                                    <label>{field}:{field === "stock_symbol"?" (string, required) - The ticker symbol of the stock.Example: AAPL, MSFT, TSLA"
                                    :null}{field === "authorization"?" (string, required) - Your API access token. Example: API_TOKEN_123 ":null} </label>
                                </div>
                            ))
                }
            </div>
            
            <div className="section-placeholder-dashboard-item">
                <div className="section-placeholder-dashboard-item-top">
                    <div className="section-placeholder-dashboard-inner-item">
                    <FaCheck className="section-placeholder-dashboard-inner-item-logo" /> Code Snippet
                    </div>
                </div>
                <div className="section-placeholder-dashboard-item-bottom">
                    {
                        <CodeBlock apiInfo={section}></CodeBlock>
                    }
                </div>
            </div>
        </div>
    );

}

export default DashBoardAPIItem;